const API_URL = 'https://www.barcodepapel.pt:5017/api/bookings';

class BookingService {
  async createBooking(bookingData) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData)
      });

      const data = await response.json();

      console.log(response)

      if (!response.ok) {
        console.log(data.message)
        throw new Error(data.message || 'Erro ao criar agendamento');
      }

      return data;
    } catch (error) {
      console.error('Erro ao criar agendamento:', error);
      throw error;
    }
  }

  async createBookingForClient(bookingData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`https://www.barcodepapel.pt:5017/api/admin/create-booking-for-client`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookingData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao criar booking');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao criar booking para cliente:', error);
      throw error;
    }
  }

  async getUserBookings() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar agendamentos');
      }

      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  }

  async getBooking(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(`${API_URL}/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar agendamento');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar agendamento:', error);
      throw error;
    }
  }

  async cancelBooking(id) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(`${API_URL}/${id}/cancel`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao cancelar agendamento');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao cancelar agendamento:', error);
      throw error;
    }
  }

  async getAllBookings() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(`${API_URL}/admin/all`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar todos os agendamentos');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar todos os agendamentos:', error);
      throw error;
    }
  }

  async adminCancelBooking(bookingId) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`https://www.barcodepapel.pt:5017/api/admin/cancel-booking/${bookingId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao cancelar reserva');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao cancelar reserva:', error);
      throw error;
    }
  }

  async adminUpdateBooking(bookingId, updateData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Token não encontrado');

      const response = await fetch(`https://www.barcodepapel.pt:5017/api/admin/update-booking/${bookingId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao atualizar reserva');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao atualizar reserva:', error);
      throw error;
    }
  }

  async getAllBookingsPublic() {
    try {
      const response = await fetch(`${API_URL}/public/occupied-slots`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar horários ocupados');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar horÃƒrios ocupados:', error);
      return [];
    }
  }

  // Novos mÃƒÂ©todos para participantes
  async addParticipants(bookingId, participants) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(`${API_URL}/${bookingId}/participants`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(participants)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao adicionar participantes');
      }

      return data;
    } catch (error) {
      console.error('Erro ao adicionar participantes:', error);
      throw error;
    }
  }

  async checkMissingParticipants() {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token nÃƒÂ£o encontrado');
      }

      const response = await fetch(`${API_URL}/check-missing-participants`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao verificar participantes');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao verificar participantes:', error);
      throw error;
    }
  }

  async updateParticipantPresence(bookingId, participantId, isPresent) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      console.log(bookingId, participantId, isPresent);

      const response = await fetch(`${API_URL}/admin/${bookingId}/participants/${participantId}/presence`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ IsPresent: isPresent })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar presença');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar presença:', error);
      throw error;
    }
  }

  async updateBookingStatus(bookingId, status) {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/${bookingId}/status`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar status');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  }

  async updateParticipantCacifo(bookingId, participantId, numeroCacifo) {
    try {

      console.log(bookingId, participantId, numeroCacifo);
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/${bookingId}/participants/${participantId}/cacifo`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Cacifo: numeroCacifo })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Erro ao atualizar cacifo');
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar cacifo:', error);
      throw error;
    }
  }
  async getAvailability(eventType, startDate = null, endDate = null) {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate.toISOString());
      if (endDate) params.append('endDate', endDate.toISOString());

      const response = await fetch(`${API_URL}/availability/${eventType}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao buscar disponibilidade');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar disponibilidade:', error);
      throw error;
    }
  }

  async checkSlotAvailability(dateTime, eventType, numParticipants = null) {
    try {
      const params = new URLSearchParams({
        dateTime: dateTime.toISOString(),
        eventType: eventType,
      });

      if (numParticipants) {
        params.append('numParticipants', numParticipants.toString());
      }

      const response = await fetch(`${API_URL}/check-slot?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Erro ao verificar disponibilidade do slot');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao verificar slot:', error);
      throw error;
    }
  }
}

export default new BookingService();